import { Typography } from '@mui/material'
import type { TypographyProps } from '@mui/material'

/** Page title for Setup section screens (1.125rem, semibold). */
const SetupPageTitle = ({ sx, children, ...props }: TypographyProps) => {
  return (
    <Typography
      variant="h4"
      sx={{
        whiteSpace: 'nowrap',
        fontWeight: 600,
        fontSize: '1.125rem',
        ...sx,
      }}
      {...props}>
      {children}
    </Typography>
  )
}

export default SetupPageTitle
